var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTgfooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#F5F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5806 17.3106C33.7454 16.245 32.7324 15.4039 31.7849 15.8199L12.9144 24.105C12.2349 24.4033 12.2847 25.4326 12.9893 25.6569L16.8808 26.8962C17.6237 27.1328 18.4279 27.0104 19.0765 26.5623L27.8503 20.5008C28.1149 20.3179 28.4033 20.6942 28.1772 20.9271L21.8616 27.4385C21.249 28.0702 21.3705 29.1406 22.1075 29.6026L29.1785 34.0368C29.9716 34.5341 30.9918 34.0345 31.1401 33.0761L33.5806 17.3106Z",
    fill: "#030930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgfooter);
export default __webpack_public_path__ + "static/media/tgfooter.9c8f8cbb03d64c8ce31754cc732e3e05.svg";
export { ForwardRef as ReactComponent };